//@ts-check
import {createContext, useContext} from 'react'

/**
 * Shares live bulk-edit state (`isEditMode`/`editedValues`/`onEditValueChange`) with table cells.
 * Needed because Peacock DS's DataTable memoizes its cell renderers independently of the
 * `columns` prop, so cells read this via context instead of via stale closured props -
 * context consumers always re-render with the latest value regardless of that memoization.
 */
const ProductListEditContext = createContext(
  /** @type {{isEditMode: boolean, editedValues: Record<string, Record<string, any>>, onEditValueChange: (productId: string, columnKey: string, value: any) => void, frozenProductIds: Set<string>}} */ ({
    isEditMode: false,
    editedValues: {},
    onEditValueChange: () => {},
    frozenProductIds: new Set(),
  })
)

export const ProductListEditProvider = ProductListEditContext.Provider

export const useProductListEditContext = () => useContext(ProductListEditContext)
